<template>
  <div>
    <el-dialog
      :title="editType == 1 ? $t('lang.修改名称') : $t('lang.修改价格')"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :append-to-body="true"
    >
      <el-form
        :model="deviceForm"
        :rules="rules"
        ref="deviceForm"
        label-width="140px"
        :hide-required-asterisk="true"
      >
        <el-form-item
          :label="$t('lang.设备名称')"
          v-if="editType == 1"
          prop="meterName"
        >
          <el-input
            v-model="deviceForm.meterName"
            :placeholder="$t('lang.请输入设备名称')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.水价')" v-if="editType == 2">
          <el-select v-model="deviceForm.priceId">
            <el-option
              v-for="item in priceList"
              :key="item.priceId"
              :label="item.priceValue.toFixed(2) + monetary + '/m³'"
              :value="item.priceId"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{
          $t("lang.取消")
        }}</el-button>
        <el-button type="primary" @click="onClickSubmit" :loading="loading">{{
          $t("lang.确定")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  inject: ["equipmentPage"],
  components: {},
  data() {
    var meterNameRule = (rule, value, callback) => {
      let reg = /(-|#|;|'|''|\\)|[\x00-\x1F]/gi;
      if (reg.test(value)) {
        callback(new Error(this.$t("lang.不能有特殊字符")));
      } else if (value.trim() == "") {
        callback(new Error(this.$t("lang.请输入设备名称")));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      dialogVisible: false,
      editType: 1,
      deviceForm: {
        meterName: "",
        pointId: "",
        priceId: "",
      },
      priceList: [],
      deviceInfo: "",
      rules: {
        meterName: [
          {
            required: true,
            validator: meterNameRule,
            trigger: "blur",
          },
        ],
      },
      monetary: "元",
    };
  },
  mounted() {},
  methods: {
    ...mapActions({
      changeDeviceName: "ZD_ChangeDeviceName",
      waterPricesList: "ZD_WaterPricesList",
      equipmentWaterEditPrice: "ZD_EquipmentWaterEditPrice",
    }),
    async dialogVisibleShow(type, data) {
      this.dialogVisible = true;
      this.monetary = localStorage.getItem("monetary");
      this.deviceForm.priceId = "";
      this.editType = type;
      if (type == 1) {
        this.deviceForm.meterName = data.deviceName;
        this.deviceForm.pointId = data.pointId;
      } else if (type == 2) {
        this.deviceInfo = data;
        this.deviceForm.pointId = data.pointId;
        let res = await this.waterPricesList({});
        if (res.success !== 1) return;
        this.priceList = res.listitem;
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.$refs.deviceForm.resetFields();
    },
    async onClickSubmit() {
      this.loading = true;
      try {
        if (this.editType == 1) {
          await this.$refs.deviceForm.validate();
          this.deviceForm.meterName = this.deviceForm.meterName.trim();
          let res = await this.changeDeviceName({
            value: this.deviceForm,
          });
          if (res.success !== 1) return;
        } else {
          if (this.deviceForm.priceId == "") {
            this.$message({
              message: this.$t("lang.请选择价格"),
              type: "warning",
            });
            return;
          }
          let res = await this.equipmentWaterEditPrice({
            value: {
              pointId: this.deviceInfo.pointId,
              priceId: this.deviceForm.priceId,
              price: this.priceList.find(
                (item) => item.priceId == this.deviceForm.priceId
              ).priceValue,
            },
          });
          if (res.success !== 1) return;
        }
        this.$message({
          message: this.$t("lang.修改成功"),
          type: "success",
        });
        this.$parent.refreshData();
        this.equipmentPage.$refs.rightDeviceRef.onClickQuery();
        this.equipmentPage.$refs.rightDeviceRef.onClickDetails({
          pointId: this.deviceForm.pointId,
          deviceType: 1,
        });
        this.handleClose();
      } catch {
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang='less'>
/deep/.el-dialog {
  width: 576px !important;
}
.el-form {
  padding-left: 20px;
}
.el-input {
  width: 300px;
}
/deep/.el-dialog__body {
  padding-bottom: 10px;
}
/deep/.el-form-item__label {
  width: 70px;
}
.el-select {
  width: 300px;
}
</style>
